import React from 'react';
import { NavigationAnalyticsContext } from '@atlaskit/analytics-namespaced-context';
import { ANALYTICS_CONTEXT } from '../../analytics';
import { AccountMenuContent } from '../account-menu-content';
import { AccountMenuIntlProvider } from '../account-menu-intl-provider';
import { AccountMenuLoggedOutState } from '../account-menu-logged-out-state';
import { AccountMenuPopup } from '../account-menu-popup';
export var AccountMenu = function AccountMenu(_ref) {
  var testId = _ref.testId,
    name = _ref.name,
    picture = _ref.picture,
    email = _ref.email,
    managedBy = _ref.managedBy,
    manageProfileLink = _ref.manageProfileLink,
    viewProfileLink = _ref.viewProfileLink,
    onViewProfileClick = _ref.onViewProfileClick,
    switchAccountLink = _ref.switchAccountLink,
    logOutLink = _ref.logOutLink,
    logInLink = _ref.logInLink,
    onThemeChange = _ref.onThemeChange,
    currentTheme = _ref.currentTheme;
  return /*#__PURE__*/React.createElement(NavigationAnalyticsContext, {
    data: ANALYTICS_CONTEXT
  }, /*#__PURE__*/React.createElement(AccountMenuIntlProvider, null, logInLink ? /*#__PURE__*/React.createElement(AccountMenuLoggedOutState, {
    testId: testId && "".concat(testId, "--logged-out-state"),
    logInLink: logInLink
  }) : /*#__PURE__*/React.createElement(AccountMenuPopup, {
    testId: testId,
    picture: picture,
    email: email,
    content: function content(_ref2) {
      var closePopup = _ref2.onClose;
      return /*#__PURE__*/React.createElement(AccountMenuContent, {
        testId: testId && "".concat(testId, "--content"),
        closePopup: closePopup,
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy,
        manageProfileLink: manageProfileLink,
        viewProfileLink: viewProfileLink,
        onViewProfileClick: onViewProfileClick,
        switchAccountLink: switchAccountLink,
        logOutLink: logOutLink,
        onThemeChange: onThemeChange,
        currentTheme: currentTheme
      });
    }
  })));
};